import React from "react";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import VpnPolicy from "../components/policy/VpnPolicy";
import PromoBanner from "../components/footer/component/PromoBanner";

export default function Policy() {
  return (
    <>
      <Header />
      <VpnPolicy />

      <div className="container mx-auto my-[40px] block md:hidden">
        <PromoBanner />
      </div>
      <Footer />
    </>
  );
}
